/**
 * SIMPLIFIED AUTH0 COMPLETION HANDLER
 *
 * Marks Auth0 transfer as complete and cleans up temporary storage.
 *
 * This saga:
 * 1. Listens for SET_AUTH0_TOKEN (token received)
 * 2. Sets auth0_transfer_completed flag (prevent re-execution)
 * 3. Cleans up temporary storage keys
 * 4. Logs completion
 */

export const completeAuth0Transfer = function* (action) {
    try {
        // Verify token is in action
        if (!action?.token) {
            return;
        }

        // Mark transfer as completed
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem('auth0_transfer_completed', 'true');
        }

        // Clean up temporary storage
        const keysToRemove = ['auth0_session_transfer_token', 'auth0_redirect_attempted', 'auth0_oauth_state', 'auth0_pkce_verifier'];

        if (typeof sessionStorage !== 'undefined') {
            keysToRemove.forEach((key) => {
                sessionStorage.removeItem(key);
            });
        }

        if (typeof localStorage !== 'undefined') {
            keysToRemove.forEach((key) => {
                localStorage.removeItem(key);
            });
        }
    } catch (error) {
        console.error('[AUTH0] Completion error:', error?.message || error);
    }
};

// Export for saga listener registration
export default [['SET_AUTH0_TOKEN'], completeAuth0Transfer];
